import { bool, func } from 'prop-types';
import React from 'react';
import { Col, FormGroup, Label, Row } from 'reactstrap';

import Association from '../../associations/Association';
import ProgressSelect from '../../generic/ProgressSelect';
import ShareInput from '../../generic/ShareInput';
import SingleSelect from '../../generic/SingleSelect';
import {
  billingTypes,
  coInvestTypes,
  negotiatedByOptions,
  salesChannels,
  stages,
} from '../../opportunities/constants';
import AgreementOpportunities from '../../opportunities/OpportunityForm/AgreementOpportunities';
import OpportunityBudget from '../../opportunities/OpportunityForm/OpportunityBudget';
import { opportunityShape } from '../../prop-types';

function ProjectOpportunityForm({ opportunity, onChange, isEditing }) {
  const {
    name,
    stage,
    pc1Id,
    pc2Id,
    commercialPackageId,
    coInvestType,
    billingType,
    salesChannel,
    negotiatedBy,
    probability,
  } = opportunity;
  const inputProps = { readOnly: !isEditing, onChange };

  return (
    <>
      <Row className="mb-5">
        <Col>
          <ProgressSelect
            id="op-stage"
            name="stage"
            resourceName={name}
            options={stages}
            value={stage}
            {...inputProps}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup row>
            <Label sm={4} for="op-agreements">
              Agreements
            </Label>
            <Col sm={8}>
              <AgreementOpportunities
                opportunity={opportunity}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          <OpportunityBudget opportunity={opportunity} {...inputProps} />
          <FormGroup row>
            <Label sm={4} for="op-probability">
              Probability
            </Label>
            <Col sm={8}>
              <ShareInput
                className="text-nowrap"
                value={probability}
                id="op-probability"
                name="probability"
                readOnly
              />
            </Col>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup row>
            <Label sm={4} for="op-pc1Id">
              PC 1
            </Label>
            <Col sm={8}>
              <Association
                id="op-pc1Id"
                name="pc1Id"
                value={pc1Id}
                type="user"
                {...inputProps}
                showIcon
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="op-pc2Id">
              PC 2
            </Label>
            <Col sm={8}>
              <Association
                id="op-pc2Id"
                name="pc2Id"
                value={pc2Id}
                type="user"
                {...inputProps}
                showIcon
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="op-negotiatedBy" className="required">
              Negotiated By
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={negotiatedByOptions}
                id="op-negotiatedBy"
                name="negotiatedBy"
                value={negotiatedBy}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="op-salesChannel" className="required">
              Sales Channel
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={salesChannels}
                id="op-salesChannel"
                name="salesChannel"
                value={salesChannel}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="op-billingType" className="required">
              Billing Type
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={billingTypes}
                id="op-billingType"
                name="billingType"
                value={billingType}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="op-coInvestType">
              Co-Invest Type
            </Label>
            <Col sm={8}>
              <SingleSelect
                options={coInvestTypes}
                id="op-coInvestType"
                name="coInvestType"
                value={coInvestType}
                {...inputProps}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="op-commercialPackageId">
              Commercial Package
            </Label>
            <Col sm={8}>
              <Association
                id="op-commercialPackageId"
                name="commercialPackageId"
                value={commercialPackageId}
                type="commercialPackage"
                {...inputProps}
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}

ProjectOpportunityForm.propTypes = {
  opportunity: opportunityShape.isRequired,
  onChange: func.isRequired,
  isEditing: bool.isRequired,
};

export default ProjectOpportunityForm;
